import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-4 mr-4"
}

import { ComputedRef, WritableComputedRef, computed } from "vue";
import { useStore } from "vuex";
import TwLabel from "../TwLabel.vue";
import TwTextarea from "../TwTextarea.vue";
import TwButtonsYesAndNo from "../TwButtonsYesAndNo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: '2.HaveReceivedBotoxAndOthers',
  setup(__props) {

const store = useStore();

const haveReceivedBotoxAndOthers: ComputedRef<boolean> = computed(
  () => store.state.form.have_received_botox_and_others
);
const haveReceivedBotoxAndOthersDetails: WritableComputedRef<string> = computed(
  {
    get: () => store.state.form.have_received_botox_and_others_details,
    set: (value) =>
      store.dispatch("updateHaveReceivedBotoxAndOthersDetails", value),
  }
);

const updateHaveReceivedBotoxAndOthers = (value: boolean) => {
  store.dispatch("updateHaveReceivedBotoxAndOthers", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[haveReceivedBotoxAndOthers.value == null ? 'bg-red-500' : ''], "p-2"])
  }, [
    _createVNode(TwLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("have_you_received_botox_and_others")), 1)
      ]),
      _: 1
    }),
    _createVNode(TwButtonsYesAndNo, {
      isActive: haveReceivedBotoxAndOthers.value,
      onOnClickYes: _cache[0] || (_cache[0] = ($event: any) => (updateHaveReceivedBotoxAndOthers(true))),
      onOnClickNo: _cache[1] || (_cache[1] = ($event: any) => (updateHaveReceivedBotoxAndOthers(false)))
    }, null, 8, ["isActive"]),
    (haveReceivedBotoxAndOthers.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(TwLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("details")), 1)
            ]),
            _: 1
          }),
          _createVNode(TwTextarea, {
            modelValue: haveReceivedBotoxAndOthersDetails.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((haveReceivedBotoxAndOthersDetails).value = $event)),
            rows: 2,
            id: "haveReceivedBotoxAndOthersDetails"
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})